import { defineComponent, h, useAttrs } from 'vue'

export default defineComponent({
  name: 'VStepperHeaderCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,

  setup(_, { slots }) {
    const attrs = useAttrs()

    return () =>
      h(
        'div',
        {
          ...attrs,
          class: ['v-stepper-header', 'v-stepper__header', attrs.class]
        },
        slots.default?.()
      )
  }
})
